/* eslint-disable graphql/template-strings */
/* eslint-disable max-len */
import { Injectable } from '@angular/core';
import { DocumentNode } from 'graphql';
import * as apollo from 'apollo-link';
import { gql } from 'graphql-tag';
import { filter, first } from 'rxjs/operators';
import {
  Operation,
  CommunicationChannel,
} from '..';

import { GraphqlApiService } from '../../graphql-api/graphql-api.service';

export interface GetCommunicationChannelForStickInput {
  loggerId: string;
  operation: Operation;
}
const build = (_query: DocumentNode, input: GetCommunicationChannelForStickInput, name = 'QueryResult') => {
  const bQuery = `
  query ${ name }(`+
    ( input.loggerId !== undefined ? `$loggerId: String = ${JSON.stringify(input.loggerId).replace(/"(\w+)":/g, '$1:')}, ` : '' ) + ``+
    ( input.operation !== undefined ? `$operation: Operation = ${input.operation}` : '' ) + `){
    getCommunicationChannelForStick(
      ${ input.loggerId !== undefined ? 'loggerId: $loggerId,' : '' } 
      ${ input.operation !== undefined ? 'operation: $operation,' : '' }
    ){
      ...communicationchannel
    }
  }`;
  return gql`
  ${bQuery}
  ${_query}
`};

@Injectable({
  providedIn: 'root',
})
export class GetCommunicationChannelForStickQuery {
  readonly graphqlClient$ = this.graphqlApiService.client$.pipe(
    filter((available) => !!available),
  );

  readonly build = build;

  constructor(
    private readonly graphqlApiService: GraphqlApiService,
  ) { }

  /**
   * fragment communicationchannel on CommunicationChannel { ... }
   */
  async execute(_query: DocumentNode, input: GetCommunicationChannelForStickInput, refresh = false) {
    const client = await this.graphqlClient$.pipe(first()).toPromise();
    if (!client) {
      throw Error('Missing graphql client!');
    }
    const fetchPolicy = refresh ? 'network-only' : 'cache-first';
   return await client?.query<{ getCommunicationChannelForStick: Partial<CommunicationChannel> }>({ query: build(_query, input), fetchPolicy });
  }
}
